document.querySelectorAll('.wizzy-search-icon').forEach(icon => {
  icon.addEventListener('click', () => {
    setTimeout(() => {
      if (window.innerWidth > 768) {
        document.querySelector('.search-input > input')?.click();
      }

      if (window.innerWidth < 768) {
        const inputs = document.querySelectorAll('.search-input > input');
        const secondInput = inputs[1];

        if (secondInput) {
          secondInput.click();
        }
      }
    }, 300);
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   const searchInput = document.querySelector(".search-input input[type='search']");
//   const clearBtn = document.querySelector(".search-input button.text-subdued");

//   if (searchInput && clearBtn) {
//     clearBtn.addEventListener("click", (e) => {
//       e.preventDefault();
//       searchInput.value = "";
//       searchInput.focus();
//     });
//   }
// });

try {
//   if (window.innerWidth < 768) {
//     const storeHeader = document.querySelector("store-header");
//     const mainNav = document.querySelector(".header__main-nav");
//     const secondaryNav = document.querySelector(".header__secondary-nav");

//     if (storeHeader && mainNav) {
//       storeHeader.prepend(mainNav);
//     }

//     if (storeHeader && secondaryNav) {
//       storeHeader.append(secondaryNav);
//     }
//   }

//   document.documentElement.classList.remove('lock');
//   window.addEventListener("load", function () {
//     const searchButtons = document.querySelectorAll(".search-drawer.search-drawer--full.drawer.drawer--lg");

//     searchButtons.forEach(searchButton => {
//       searchButton.style.pointerEvents = "auto";
//       searchButton.addEventListener("click", function () {
//         setTimeout(() => {
//           const searchBar = document.querySelector("#side-panel-search-input");
//           if (searchBar) {
//             searchBar.click();
//           }
//         }, 500);
//       });
//     });
//   });

  window.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
      document.body.classList.add("scrolled-happened");
    } else {
      document.body.classList.remove("scrolled-happened");
    }
  });

  let varientMapper = {
  "Acacia": "https://nathanjames.com/cdn/shop/files/acacia.png?v=1623874692&width=72",
  "Acacia-Black": "https://nathanjames.com/cdn/shop/files/acacia-black.png?v=1681061388&width=72",
  "Antique Coffee-Wheat": "https://nathanjames.com/cdn/shop/files/antique-coffee-wheat.png?v=1681061408&width=72",
  "Beige": "#E8E0D1",
  "Black Oak": "https://nathanjames.com/cdn/shop/files/black-oak.png?v=1701888258&width=72",
  "Black Oak-Black Rattan": "https://nathanjames.com/cdn/shop/files/black-oak-black-rattan.png?v=1767834970&width=72",
  "Black Oak-Cream Boucle": "https://nathanjames.com/cdn/shop/files/black-oak-cream-boucle.jpg?v=1703117853&width=72",
  "Black Oak-Gold": "https://nathanjames.com/cdn/shop/files/black-oak-gold.jpg?v=1715669451&width=72",
  "Black Oak-Light Oak-Synthetic Rattan-Matte Black": "https://nathanjames.com/cdn/shop/files/black-oak-synthetic-rattan-matte-black.jpg?v=1707941911&width=72",
  "Black Oak-Pale Rattan": "https://nathanjames.com/cdn/shop/files/black-oak-pale-rattan.jpg?v=1767835225&width=72",
  "Black Oak-Rattan-Matte Black": "https://nathanjames.com/cdn/shop/files/black-oak-natural-rattan-matte-black.png?v=1695161691&width=72",
  "Black Oak-Synthetic Rattan-Matte Black": "https://nathanjames.com/cdn/shop/files/black-oak-faux-rattan-matte-black.png?v=1695162906&width=72",
  "Black Oak-Vintaged Brass-Seagrass": "https://nathanjames.com/cdn/shop/files/black-oak-seagrass.jpg?v=1746163336&width=72",
  "Black": "https://nathanjames.com/cdn/shop/files/black.png?v=1672847273&width=72",
  "Black-Cream Boucle": "https://nathanjames.com/cdn/shop/files/black-cream-linen.png?v=1694185605&width=72",
  "Black-Matte Black": "https://nathanjames.com/cdn/shop/files/matte-black-black.png?v=1722024518&width=72",
  "Black-Seagrass": "https://nathanjames.com/cdn/shop/files/black-seagrass.png?v=1736331352&width=72",
  "Boucle White Rough-Matte Black": "https://nathanjames.com/cdn/shop/files/boucle-white-rough-matte-black.png?v=1681061231&width=72",
  "Brushed Black-Seagrass": "https://nathanjames.com/cdn/shop/files/brushed-black-seagrass.png?v=1681061232&width=72",
  "Brushed Black-Seagrass-Polished Chrome": "https://nathanjames.com/cdn/shop/files/brushed-black-seagrass-polished-chrome.png?v=1712292610&width=72",
  "Brushed Dark Brown": "https://nathanjames.com/cdn/shop/files/brushed-dark-brown.png?v=1681061232&width=72",
  "Brushed Dark Brown-Cream Boucle": "https://nathanjames.com/cdn/shop/files/brushed-dark-brown-cream-linen.png?v=1687988199&width=72",
  "Brushed Dark Brown-Feather Ivory-Pewter": "https://nathanjames.com/cdn/shop/files/brushed-dark-brown-feather-ivory-pewter.png?v=1681061231&width=72",
  "Brushed Fir-Matte Black-Matte Black": "https://nathanjames.com/cdn/shop/files/brushed-fir-matte-black.jpg?v=1742289183&width=72",
  "Brushed Light Brown": "https://nathanjames.com/cdn/shop/files/brushed-light-brown.png?v=1681061232&width=72",
  "Brushed Light Brown-Cream Boucle": "https://nathanjames.com/cdn/shop/files/brushed-light-brown-cream-boucle.png?v=1698420169&width=72",
  "Brushed Light Brown-Cream Boucle-Rattan": "https://nathanjames.com/cdn/shop/files/brushed-light-brown-cream-boucle-rattan.jpg?v=1712768047&width=72",
  "Brushed Light Brown-Flax": "https://nathanjames.com/cdn/shop/files/brushed-light-brown-flax.png?v=1690838751&width=72",
  "Brushed Light Brown-Seagrass": "https://nathanjames.com/cdn/shop/files/brushed-light-brown-seagrass.png?v=1681061231&width=72",
  "Brushed Light Brown-Seagrass-Cream Boucle": "https://nathanjames.com/cdn/shop/files/brushed-light-brown-seagrass-cream-boucle.jpg?v=1707160025&width=72",
  "Brushed Light Brown-Warm Pine": "https://nathanjames.com/cdn/shop/files/warm-pine-brushed-light-brown.jpg?v=1701533959&width=72",
  "Cream Boucle-Black Seagrass-Gray Mahogany": "https://nathanjames.com/cdn/shop/files/cream-boucle-black-seagrass-gray-mahogany.png?v=1723799194&width=72",
  "Cream Boucle-Brushed Dark Brown": "https://nathanjames.com/cdn/shop/files/cream-boucle-brushed-dark-brown.png?v=1715640820&width=72",
  "Cream Boucle-Matte Black": "https://nathanjames.com/cdn/shop/files/cream-boucle-matte-black.png?v=1707159757&width=72",
  "Cream Boucle-Seagrass-Dark Brown": "https://nathanjames.com/cdn/shop/files/cream-boucle-seagrass-dark-brown.jpg?v=1722535409&width=72",
  "Cream Boucle-Warm Pine": "https://nathanjames.com/cdn/shop/files/cream-boucle-warm-pine.png?v=1698663653&width=72",
  "Dark Acacia": "https://nathanjames.com/cdn/shop/files/dark-acacia.jpg?v=1731362083&width=72",
  "Dark Acacia-Synthetic Rattan-Brushed Brass": "https://nathanjames.com/cdn/shop/files/dark-acacia-synthetic-rattan-brushed-brass.png?v=1717709477&width=72",
  "Dark Brown": "https://nathanjames.com/cdn/shop/files/white-warm-medium-walnut.png?v=1681064331&width=72",
  "Dark Brown-Light Gray Linen": "https://nathanjames.com/cdn/shop/files/dark-brown-light-gray-linen.png?v=1681061232&width=72",
  "Dark Brown-Seagrass": "https://nathanjames.com/cdn/shop/files/dark-brown-seagrass.png?v=1725529242&width=72",
  "Feather Gray-Gray Mahogany": "https://nathanjames.com/cdn/shop/files/Gray-Light_Brown.jpg?v=1762500810&width=72",
  "Feather Gray-Matte Black": "https://nathanjames.com/cdn/shop/files/feather-gray-matte-black.png?v=1681061232&width=72",
  "Feather Gray-Vintaged Brown-Matte Black": "https://nathanjames.com/cdn/shop/files/feather-gray-vintaged-brown-matte-black.png?v=1681064330&width=72",
  "Gold": "https://nathanjames.com/cdn/shop/files/gold.png?v=1653498533&width=72",
  "Graphite-Brushed Black": "https://nathanjames.com/cdn/shop/files/graphite-brushed-black.png?v=1692660244&width=72",
  "Gray Mahogany-Seagrass-Polished Chrome": "https://nathanjames.com/cdn/shop/files/gray-mahogany-seagrass-polished-chrome.png?v=1712289771&width=72",
  "Gray Oak": "https://nathanjames.com/cdn/shop/files/gray-oak.jpg?v=1742443706&width=72",
  "Gray": "https://nathanjames.com/cdn/shop/files/warm-white-dark-gray.png?v=1681064331&width=72",
  "Honey Brown-Synthetic Rattan": "https://nathanjames.com/cdn/shop/files/honey-brown-synthetic-rattan.jpg?v=1724314939&width=72",
  "Light Brown": "https://nathanjames.com/cdn/shop/files/unbrushed-light-brown.jpg?v=1733514812&width=72",
  "Light Brown-Cream Boucle-Rattan": "https://nathanjames.com/cdn/shop/files/light-brown-cream-boucle-rattan.jpg?v=1722445570&width=72",
  "Light Brown-Matte Black": "https://nathanjames.com/cdn/shop/files/light-brown-matte-black.png?v=1623874692&width=72",
  "Light Brown-Seagrass": "https://nathanjames.com/cdn/shop/files/light-brown-seagrass.jpg?v=1733211309&width=72",
  "Light Brown-Vintaged Brass-Seagrass": "https://nathanjames.com/cdn/shop/files/light-brown-seagrass_07cbd9cb-5d89-464d-814b-0f074bdd4057.jpg?v=1746163317&width=72",
  "Light Golden Oak-Matte Black": "https://nathanjames.com/cdn/shop/files/light-golden-oak-matte-black.png?v=1681061380&width=72",
  "Light Gray Oak-Matte Black": "https://nathanjames.com/cdn/shop/files/light-gray-oak-matte-black.png?v=1681061230&width=72",
  "Light Oak": "https://nathanjames.com/cdn/shop/files/light-oak.png?v=1649970994&width=72",
  "Light Oak-Rattan-Gold": "https://nathanjames.com/cdn/shop/files/light-oak-natural-rattan-gold.png?v=1695161778&width=72",
  "Light Oak-Rattan-Matte Black": "https://nathanjames.com/cdn/shop/files/light-oak-natural-rattan-matte-black.png?v=1695161725&width=72",
  "Light Oak-Synthetic Rattan-Matte Black": "https://nathanjames.com/cdn/shop/files/light-oak-faux-rattan-matte-black.png?v=1695162906&width=72",
  "Matte Black": "https://nathanjames.com/cdn/shop/files/matte-black.png?v=1623874692&width=72",
  "Matte Black-Brushed Fir": "https://nathanjames.com/cdn/shop/files/matte-black-brushed-fir.png?v=1678080431&width=72",
  "Matte Black-Light Oak": "https://nathanjames.com/cdn/shop/files/matte-black-light-oak.png?v=1686255148&width=72",
  "Matte Black-Rattan-Gold": "https://nathanjames.com/cdn/shop/files/matte-black-natural-rattan-gold.png?v=1695162180&width=72",
  "Matte Black-Vintaged Brass": "https://nathanjames.com/cdn/shop/files/matte-black-vintaged-brass.png?v=1681061231&width=72",
  "Matte White": "https://nathanjames.com/cdn/shop/files/matte-white.png?v=1623874944&width=72",
  "Matte White-Light Oak": "https://nathanjames.com/cdn/shop/files/matte-white-light-oak.png?v=1692814716&width=72",
  "Matte White-Light Oak-Rattan-Gold": "https://nathanjames.com/cdn/shop/files/matte-white-light-oak-rattan-gold.png?v=1681061231&width=72",
  "Matte White-Natural Wash-Pale Gold": "https://nathanjames.com/cdn/shop/files/matte-white-natural-wash-pale-gold.png?v=1681061230&width=72",
  "Matte White-Rattan-Gold": "https://nathanjames.com/cdn/shop/files/matte-white-natural-rattan-gold.png?v=1695163506&width=72",
  "Matte White-Synthetic Rattan-Gold": "https://nathanjames.com/cdn/shop/files/matte-white-faux-rattan-gold.png?v=1695163536&width=72",
  "Medium Brown": "https://nathanjames.com/cdn/shop/files/acacia.png?v=1623874692&width=72",
  "Modern Brown-Cream Boucle": "https://nathanjames.com/cdn/shop/files/modern-brown-cream-linen.png?v=1695223755&width=72",
  "Nutmeg-Matte Black": "https://nathanjames.com/cdn/shop/files/nutmeg-matte-black.png?v=1682005901&width=72",
  "Pale Oak": "https://nathanjames.com/cdn/shop/files/pale-oak.png?v=1767995866&width=72",
  "Raw Oak": "https://nathanjames.com/cdn/shop/files/raw-oak.jpg?v=1729612845&width=72",
  "Raw Oak-Brushed Brass-Rattan": "https://nathanjames.com/cdn/shop/files/raw-oak-brushed-brass-rattan.png?v=1731312248&width=72",
  "Raw Oak-Seagrass": "https://nathanjames.com/cdn/shop/files/raw-oak-seagrass.jpg?v=1732521059&width=72",
  "Reclaimed Oak-Gunmetal": "https://nathanjames.com/cdn/shop/files/reclaimed-oak-gunmetal.png?v=1681064330&width=72",
  "Reclaimed Oak-Matte Black": "https://nathanjames.com/cdn/shop/files/reclaimed-oak-matte-black.png?v=1623874692&width=72",
  "Reclaimed Oak-Matte White": "https://nathanjames.com/cdn/shop/files/reclaimed-oak-matte-white.png?v=1681061232&width=72",
  "Vintaged Brass": "https://nathanjames.com/cdn/shop/files/vintaged-brass.png?v=1664791827&width=72",
  "Vintaged Brass-Matte Black": "https://nathanjames.com/cdn/shop/files/vintaged-brass-matte-black.png?v=1675545181&width=72",
  "Vintaged Brass-White": "https://nathanjames.com/cdn/shop/files/vintaged-brass-white.png?v=1681061232&width=72",
  "Vintaged Brown-Matte Black": "https://nathanjames.com/cdn/shop/files/vintaged-brown-matte-black.png?v=1681064330&width=72",
  "Walnut": "https://nathanjames.com/cdn/shop/files/walnut.png?v=1681061232&width=72",
  "Walnut-Matte Black": "https://nathanjames.com/cdn/shop/files/walnut-matte-black.png?v=1681061232&width=72",
  "Walnut-Synthetic Rattan-Matte Black": "https://nathanjames.com/cdn/shop/files/walnut.jpg?v=1719597032&width=72",
  "Warm Oak": "https://nathanjames.com/cdn/shop/files/warm-oak.png?v=1767995562&width=72",
  "Warm Pine": "https://nathanjames.com/cdn/shop/files/warm-pine.png?v=1681061233&width=72",
  "Warm Pine-Brushed Light Brown": "https://nathanjames.com/cdn/shop/files/warm-pine-brushed-light-brown.png?v=1680904932&width=72",
  "Warm Pine-Chestnut": "https://nathanjames.com/cdn/shop/files/warm-pine-chestnut.png?v=1681061232&width=72",
  "Warm Pine-Cream Boucle": "https://nathanjames.com/cdn/shop/files/warm-pine-cream-boucle.png?v=1698420239&width=72",
  "Warm Pine-Cream Boucle-Rattan": "https://nathanjames.com/cdn/shop/files/warm-pine-cream-boucle-rattan.png?v=1701362138&width=72",
  "Warm Pine-Gold": "https://nathanjames.com/cdn/shop/files/warm-pine-gold.png?v=1689862504&width=72",
  "Warm Pine-Synthetic Rattan": "https://nathanjames.com/cdn/shop/files/warm-pine-synthetic-rattan.jpg?v=1723654188&width=72",
  "Warm Pine-Warm Synthetic Rattan": "https://nathanjames.com/cdn/shop/files/warm-pine-warm-faux-rattan.png?v=1695164151&width=72",
  "Warm White-Seagrass": "https://nathanjames.com/cdn/shop/files/warm-white-seagrass.png?v=1689195134&width=72",
  "Warm White-Warm Pine": "https://nathanjames.com/cdn/shop/files/warm-white-warm-pine-gold.png?v=1715011701&width=72",
  "White Oak-Boucle White Rough": "https://nathanjames.com/cdn/shop/files/white-oak-boucle-white-rough.jpg?v=1751294919&width=72",
  "White Oak-Off White": "https://nathanjames.com/cdn/shop/files/white-oak-off-white.jpg?v=1718877227&width=72",
  "White": "https://nathanjames.com/cdn/shop/files/white.png?v=1623874944&width=72",
  "White-Gold": "https://nathanjames.com/cdn/shop/files/white-gold.png?v=1623874944&width=72",
  "White-Rattan-Gold": "https://nathanjames.com/cdn/shop/files/white-rattan-gold.png?v=1681061233&width=72",
  "Beige": "#E8E0D1"
  };

  function findHaxCode(key) {
    return varientMapper[key] ? [varientMapper[key], true] : [key, false]
  }

  function gridFiltersToggleOnOverflow() {
    if (window.innerWidth > 768) {
      const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

      if (filterBoxes.length > 0) {
        filterBoxes.forEach((box) => {
          const filterList = box.querySelector(
            ".wizzy-facet-body .wizzy-facet-list"
          );
          const toggleBtn = box.querySelector(
            ".wizzy-facet-body .wizzy-toggle-btn"
          );
          const filterOptions = box.querySelector(".wizzy-facet-body");

          if (
            filterList &&
            toggleBtn &&
            filterOptions &&
            !toggleBtn.classList.contains("wizzy-click-event-attached")
          ) {
            const filterHeight = filterList.offsetHeight;
            const lineHeight = parseFloat(
              getComputedStyle(filterList).lineHeight
            );
            const maxVisibleLines = 2;
            const visibleLines = Math.floor(filterHeight / lineHeight) - 1;

            if (visibleLines > maxVisibleLines) {
              filterOptions.classList.add("collapsed");
              toggleBtn.classList.add("wizzy-click-event-attached");
              toggleBtn.style.display = "inline-block";
            } else {
              toggleBtn.style.display = "none";
            }

            toggleBtn.addEventListener("click", function () {
              if (filterOptions.classList.contains("collapsed")) {
                filterOptions.classList.remove("collapsed");
                filterOptions.classList.add("expanded");
                toggleBtn.innerText = "- Less";
              } else {
                filterOptions.classList.remove("expanded");
                filterOptions.classList.add("collapsed");
                toggleBtn.innerText = "+ More";
              }
              toggleBtn.classList.add("wizzy-click-event-attached");
            });
          }
        });
      }
    }
  }

  function splitSuggestionsIntoColumns() {
    const wrapper = document.querySelector('.wz-autocomplete-sugegstions-products-wrapper');
    if (!wrapper) return;

    const suggestionsBox = wrapper.querySelector('.wizzy-autocomplete-suggestions');
    const suggestionsList = suggestionsBox.querySelector('.autocomplete-suggestions-list');
    const topProductsBox = wrapper.querySelector('.wizzy-autocomplete-top-products');
    const items = Array.from(suggestionsList.children);

    const collectionsIndex = items.findIndex(li => li.dataset.index === "0");
    const suggestionsIndex = items.findIndex(li => li.dataset.index === "2");

    if (collectionsIndex === -1 || suggestionsIndex === -1) return;

    const suggestionsGroup = items.slice(suggestionsIndex);
    const collectionsGroup = items.slice(collectionsIndex, suggestionsIndex);

    // Create new wrappers while keeping existing class names
    const suggestionsWrapper = document.createElement('div');
    suggestionsWrapper.classList.add('suggestions-wrapper', 'column-wrapper');

    const collectionsWrapper = document.createElement('div');
    collectionsWrapper.classList.add('collections-wrapper', 'column-wrapper', 'wizzy-autocomplete-suggestions');

    const newSuggestionsList = document.createElement('ul');
    newSuggestionsList.className = 'autocomplete-suggestions-list';
    suggestionsGroup.forEach(li => newSuggestionsList.appendChild(li));
    suggestionsWrapper.appendChild(suggestionsBox);
    suggestionsBox.innerHTML = '';
    suggestionsBox.appendChild(newSuggestionsList);

    const newCollectionsList = document.createElement('ul');
    newCollectionsList.className = 'autocomplete-suggestions-list';
    collectionsGroup.forEach(li => newCollectionsList.appendChild(li));
    collectionsWrapper.appendChild(newCollectionsList);

    // Clean up wrapper and re-append
    wrapper.innerHTML = '';
    wrapper.appendChild(suggestionsWrapper); 
    wrapper.appendChild(topProductsBox);      
    wrapper.appendChild(collectionsWrapper); 
  }

function positionAutocompleteBelowSearch() {
    const searchInput = document.querySelector(".header__wrapper .search-input");
    const autoComplete = document.querySelector(".wizzy-autocomplete-wrapper");

    if (!searchInput || !autoComplete) return;

    const rect = searchInput.getBoundingClientRect();

    const extraLeft = 290;
    const extraRight = 170;

    const finalWidth = rect.width + extraLeft + extraRight;

    autoComplete.style.width = finalWidth + "px";
    autoComplete.style.top = (rect.bottom + window.scrollY + 6) + "px";

    autoComplete.style.left = (rect.left + window.scrollX - extraLeft) + "px";
}
document.querySelector(".header__wrapper .search-input")
.addEventListener("click", () => {
    setTimeout(positionAutocompleteBelowSearch, 20);
});


  window.onWizzyScriptLoaded = function () {

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
      function (data) {
        document.addEventListener("click", function () {
          const drawers = document.querySelectorAll("#search-drawer"); // all with same id
          drawers.forEach(drawer => {
            if (drawer.hasAttribute("inert")) {
              drawer.removeAttribute("inert");
            }
          });
        });

        document.querySelector('.search-input .icon.icon-close').closest('button').click();
        document.documentElement.classList.remove('lock');
        return data; 
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
      function (data) {
      if (data.group === "noProductsFound") {
          data.filters.sort = [
              {
                  field: "product_bestseller_sortOrder:float",
                  order: "asc"
              }
          ];
      }

        return data; 
      }
    );
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload?.response?.payload?.facets;
        if (facets) {
          facets.forEach((facet) => {
            if (facet.key === "product_color_custom") {
              let facet_data = facet.data;
              if (facet_data) {
                facet_data.forEach((item) => {
                  let color = varientMapper[item.label] || "#000000";

                  const isHex = color.startsWith("#");
                  const isURL = color.startsWith("http");

                  item.isSwatch = true;
                  item.isVisualSwatch = true;

                  item.isHexSwatch = isHex;
                  item.isURLSwatch = isURL;

                  item.swatchValue = color;

                  item.data = {
                    value: item.key,
                    swatch: {
                      type: "visual",
                      value: color,
                    },
                  };

                  item.code = color;
                });

              }
            }
          });
        }
      }
      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
      function (data) {
          // window.wizzyConfig.react = window.wizzyConfig.react || {};
          // window.wizzyConfig.react = {
          //     enabled: true
          //     // component: {
          //     //     topProducts: window.CustomTopProducts,
          //     //     suggestions: window.CustomSuggestions
          //     // }
          // };
        window.wizzyConfig.autocomplete.searchBar.hasAnimatedPlaceholders = false;
        window.wizzyConfig.autocomplete.searchBar.animatedPlaceholders = [];
        data.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];
        return data;
      });
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        // window.wizzyConfig.react = window.wizzyConfig.react || {};
          // window.wizzyConfig.react = {
          //     enabled: true
          //     component: {
          //         topProducts: window.CustomTopProducts,
          //         suggestions: window.CustomSuggestions
          //     }
          // };

        window.wizzyConfig.autocomplete.searchBar.hasAnimatedPlaceholders = false;
        window.wizzyConfig.autocomplete.searchBar.animatedPlaceholders = [];
        data.search.configs.facets.leftFacets.mobileCollapsible = !0;
        data.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];
        return data;
      });
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function (products) {
        const discountMode = window.discountMode;
        const threshold = Number(window.discountThreshold || 39);
        products.forEach((product) => { 
          product.attributes.forEach((attr) => {
            if (attr.id === "product_variation_products_custom") {
              let swatchvalue = attr.values[0].value[0];
              try {
                product.variantsData = JSON.parse(swatchvalue);

                if (Array.isArray(product.variantsData)) {
                  product.variantsData.forEach((variant) => {
                    if (Array.isArray(variant.options)) {
                      variant.options.forEach((option) => {
                        const [url, isMatched] = findHaxCode(option.value);
                        if (isMatched) {
                          option.variantUrl = url;
                          option.isHex = url.startsWith("#");
                        }
                      });
                    }
                  });
                }

              } catch (e) {
                console.error("Error parsing swatch value:", e);
              }
            }
            if (attr.id === "product_template_suffix") {
              let templateSuffixValue = attr.values[0].value[0];
              if(templateSuffixValue === "grouped-products"){
                product.showSwatch = true; 
              }
            }            
          });
          const discount = Number(product.discountPercentage || 0);
          if (discountMode == 'percentage' && discount != 0) {
            product.showSaleBadge = true;
          } else {
            product.showSaleBadge = discount > threshold;
          }

          product.showComparePrice = (discount != 0);
        });

        // let avgRatings = "";
        products.forEach((product) => {
          product.attributes.forEach((attr) => {
            if (attr.id === "product_badges_custom") {

              attr.values[0].value.forEach(val => {
                if (val === "Back in Stock")
                  product.backinstock = true;

                if (val === "New")
                  product.new = true;

                if (val === "Best Seller")
                  product.BestSeller = true;
              })
            }
          });

        })
        return products;

      });


    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
      function (data) {
        document.documentElement.classList.remove('lock');
        var applyButton = document.querySelector("#wizzy-apply-filters-button");
        var closeButton = document.querySelector(".wizzy-filters-close-btn");

        if (applyButton && closeButton) {
          applyButton.addEventListener("click", function () {
            closeButton.click();
          });
        }
        splitSuggestionsIntoColumns();
        var categories = data.data?.response?.payload?.categories;
        const links = document.querySelectorAll('.collections-wrapper .autocomplete-item .autocomplete-link');

        if (categories && links.length) {
          categories.forEach((item, index) => {
            const payload = item.payload;
            const imageData = payload.find(p => p.key === "categoryImage");
            const imageUrl = imageData?.value;

            if (imageUrl && links[index]) {
              const img = document.createElement("img");
              img.src = imageUrl;
              img.alt = item.value;
              img.style.width = "40px"; // Optional styling
              img.style.marginRight = "8px";
              img.classList.add("wizzy-autocomplete-image");
              img.style.verticalAlign = "middle";
              links[index].insertBefore(img, links[index].firstChild);
            }
          });
        }

        var sourceElement = document.querySelector('.wizzy-search-sort-wrapper');
        if (sourceElement) {
          var clonedContent = sourceElement.cloneNode(true);

          var targetDiv = document.querySelector('.wizzy-sort-wrapper-in-filter');

          if (targetDiv && !targetDiv.querySelector('.wizzy-search-sort-wrapper')) {
            targetDiv.appendChild(clonedContent);
          }
        }
        if (window.innerWidth < 768) {
          var sortInFilter = document.querySelector('.wizzy-search-filters-left-wrapper .wizzy-common-select-selector');
          if (sortInFilter && !sortInFilter.classList.contains('click-listener-attached')) {
            sortInFilter.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              var sortOptions = document.querySelector('.wizzy-common-select-options');
              if (sortOptions) {
                if (sortOptions.style.display === 'none' || sortOptions.style.display === '') {
                  sortOptions.style.display = 'grid';
                } else {
                  sortOptions.style.display = 'none';
                }
              }
            });
            sortInFilter.classList.add('click-listener-attached');
          }
        }
        gridFiltersToggleOnOverflow();

        return data
      });
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (data) {
        document.documentElement.classList.remove('lock');
        const totalProducts = data?.data?.response?.payload?.products?.total || 0;

        const element = document.querySelector(
          'p.top-products-title'
        );

        if (element) {
          console.log("element",element);
          element.textContent = `${totalProducts} Products`;
        }
        const ul = document.querySelector('.wizzy-selected-facet-list');
        const countSpan = document.querySelector('#wizzy-apply-filters-button span');

        if (ul && countSpan) {
          const liCount = ul.querySelectorAll(':scope > li').length;
          countSpan.textContent = `(${liCount})`;
        }

        var applyButton = document.querySelector("#wizzy-apply-filters-button");
        var closeButton = document.querySelector(".wizzy-filters-close-btn");

        if (applyButton && closeButton) {
          applyButton.addEventListener("click", function () {
            closeButton.click();
          });
        }
        splitSuggestionsIntoColumns();
        var categories = data.data?.response?.payload?.categories;
        const links = document.querySelectorAll('.collections-wrapper .autocomplete-item .autocomplete-link');

        if (categories && links.length) {
          categories.forEach((item, index) => {
            const payload = item.payload;
            const imageData = payload.find(p => p.key === "categoryImage");
            const imageUrl = imageData?.value;

            if (imageUrl && links[index]) {
              const img = document.createElement("img");
              img.src = imageUrl;
              img.alt = item.value;
              img.style.width = "40px"; // Optional styling
              img.style.marginRight = "8px";
              img.classList.add("wizzy-autocomplete-image");
              img.style.verticalAlign = "middle";
              links[index].insertBefore(img, links[index].firstChild);
            }
          });
        }


        var sourceElement = document.querySelector('.wizzy-search-sort-wrapper');
        if (sourceElement) {
          var clonedContent = sourceElement.cloneNode(true);

          var targetDiv = document.querySelector('.wizzy-sort-wrapper-in-filter');

          if (targetDiv && !targetDiv.querySelector('.wizzy-search-sort-wrapper')) {
            targetDiv.appendChild(clonedContent);
          }
        }
        if (window.innerWidth < 768) {
          var sortInFilter = document.querySelector('.wizzy-search-filters-left-wrapper .wizzy-common-select-selector');
          if (sortInFilter && !sortInFilter.classList.contains('click-listener-attached')) {
            sortInFilter.addEventListener('click', function (event) {
              document.body.classList.toggle("wizzy-sort-opened");
              event.preventDefault();
              event.stopPropagation();
              var sortOptions = document.querySelector('.wizzy-common-select-options');
              if (sortOptions) {
                if (sortOptions.style.display === 'none' || sortOptions.style.display === '') {
                  sortOptions.style.display = 'grid';
                } else {
                  sortOptions.style.display = 'none';
                }
              }
            });
            sortInFilter.classList.add('click-listener-attached');
          }
        }
        gridFiltersToggleOnOverflow();

        return data;
      });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function (data) {
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];

      data.endpoints.common = "https://uranus-api.wizsearch.in";

      return data;
    });

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
      function (data) {

        setTimeout(positionAutocompleteBelowSearch, 2);
        
          const storeData = localStorage.getItem("wizzy_store");


            if (storeData) {
            const parsedStore = JSON.parse(storeData);

            const viewedProducts = parsedStore?.VIEWED_PRODUCTS;
            if (Array.isArray(viewedProducts) && viewedProducts.length) {
              data.isRecentlyViewPresent = true;

            }
            else {
              document.body.classList.add("recently-not-present");
              data.isRecentlyViewPresent = false;
            }
          }


        return data;
      },
      3
    );
        window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
      function (data) {
        try {
          if(data.isForDefault){
          const storeData = localStorage.getItem("wizzy_store");

          if (storeData) {
            const parsedStore = JSON.parse(storeData);

            const viewedProducts = parsedStore?.VIEWED_PRODUCTS;

            if (Array.isArray(viewedProducts) && viewedProducts.length) {
              data.products = viewedProducts;
              data.isRecentlyViewPresent = true;
            }
          }
        }
        } catch (e) {
          console.error("Error parsing wizzy_store from localStorage", e);
        }


        return data;
      },
      2
    );
    
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER, function (data) {

      data.productsCount = data?.products?.length;

      return data;
    });

    const targetNode = document.querySelector(".wizzy-body-end-wrapper");
    function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
    }
    const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
    }
      , callback = function (mutationsList, observer2) {
        for (const mutation of mutationsList) {
          updateBodyClass();
          break
        }
      }
    ,observer = new MutationObserver(callback);
    targetNode && (observer.observe(targetNode, config),
    updateBodyClass());

  };
}
catch (e) {
  console.log(e);
}